"use strict";
/**
 * @module kung-fu/components
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotateListStyleType = void 0;
/**
 * Recursively traverses a list structure and applies list style types based on nesting level
 * When the nesting level exceeds 3, it resets back to 0, creating a repeating pattern
 *
 * @param {HTMLUListElement} elem - The list element to style
 * @param {number} level - The current nesting level
 * @param {string[]} order - Array of list style types to apply
 * @returns {void}
 * @private
 */
function traverseList(elem, level, order) {
    if (level == 3) {
        level = 0;
    }
    elem.style.listStyleType = order[level];
    const children = elem.querySelectorAll(':scope > li > ul');
    Array.from(children).forEach((el) => traverseList(el, level + 1, order));
}
/**
 * Applies rotating list style types to nested unordered lists based on their nesting level
 * Only affects top-level lists (those not contained within list items)
 *
 * @export
 * @param {string} [selector='ul'] - CSS selector for list elements
 * @param {string[]} [order=['disc', 'circle', 'square']] - List style types to apply in sequence
 * @returns {void}
 * @example
 * // Apply default styling to all unordered lists
 * rotateListStyleType();
 *
 * // Apply custom styling to specific lists with a class
 * rotateListStyleType('.custom-list', ['decimal', 'lower-alpha', 'lower-roman']);
 */
const rotateListStyleType = (selector, order) => {
    selector = selector || 'ul';
    order = order || ['disc', 'circle', 'square'];
    const uls = document.querySelectorAll(selector);
    const arr = Array.from(uls).filter((e) => e.closest('li') == null);
    arr.forEach((elem) => traverseList(elem, 0, order));
};
exports.rotateListStyleType = rotateListStyleType;
//# sourceMappingURL=bullets.js.map